import React, { FC } from 'react'
import Head from 'next/head'

export const FavIcon: FC = () => (
  <Head>
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="https://cdn.izettle.com/favicons/apple-touch-icon.png"
    />
    <link
      rel="icon"
      type="image/png"
      href="https://cdn.izettle.com/favicons/favicon-32x32.png"
      sizes="32x32"
    />
    <link
      rel="icon"
      type="image/png"
      href="https://cdn.izettle.com/favicons/favicon-16x16.png"
      sizes="16x16"
    />
    <link
      rel="manifest"
      href="https://cdn.izettle.com/favicons/manifest.json"
    />
    <link
      rel="shortcut icon"
      href="https://cdn.izettle.com/favicons/favicon.ico"
    />
  </Head>
)
